import { initWebLogger, type WebLoggerController } from "ray-logger-core";
import { UploadManager } from "ray-logger-report";
import {
  getLoggerBaseUrl,
  normalizeUploadLogOptions,
  type LoggerUploadOptions,
} from "../utils/logger";

export class PageSpyManager {
  private controller?: WebLoggerController;
  private uploadManager?: UploadManager;

  private ensureManager(): UploadManager {
    if (!this.controller) {
      this.controller = initWebLogger({
        disallowRecordRequestHeaders: [],
        disallowRecordResponseHeaders: [],
        rrwebOptions: {
          recordCanvas: false,
        },
      });
    }

    if (!this.uploadManager) {
      this.uploadManager = new UploadManager({
        baseUrl: getLoggerBaseUrl(),
        controller: this.controller,
      });
    }

    return this.uploadManager;
  }

  async uploadLog(options?: LoggerUploadOptions) {
    if (typeof window === "undefined") return;

    const uploadOptions = normalizeUploadLogOptions(options);

    await this.ensureManager().uploadSince({
      businessLine: uploadOptions.businessLine,
      userId: uploadOptions.userId,
      remark: uploadOptions.remark,
      sinceMs: uploadOptions.sinceMs,
    });
  }
}

export const pageSpyManager = new PageSpyManager();
